import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';

export const PortfolioIcon = createSvgIcon(
  <svg viewBox='0 0 20 19' xmlns='http://www.w3.org/2000/svg'>
    <path d='M13 9H9.5C9.224 9 9 9.225 9 9.5C9 9.776 9.224 10 9.5 10H10.5C11.878 10 13 11.122 13 12.5C13 13.707 12.14 14.718 11 14.95V16H9V15H7V13H10.5C10.776 13 11 12.776 11 12.5C11 12.225 10.776 12 10.5 12H9.5C8.122 12 7 10.878 7 9.5C7 8.293 7.86 7.283 9 7.051V6H11V7H13V9ZM8 2H12V3H8V2ZM18 3V2H16V3H14V1C14 0.448 13.553 0 13 0H7C6.448 0 6 0.448 6 1V3H4V2H2V3C0.897 3 0 3.897 0 5V17C0 18.103 0.897 19 2 19H18C19.104 19 20 18.103 20 17V5C20 3.897 19.104 3 18 3Z' />
  </svg>,
  'PortfolioIcon'
);
